import type { User, Withdrawal } from '@library/types/payments';
import { classNames, convertCentsToDollars } from '@library/utils';
import {
  formatWithTimezoneChange,
  getPaymentsDateTime
} from '@library/utils/dateTime';
import {
  withdrawalMethodDisplay,
  withdrawalStatusDisplay
} from '@library/component-utils/paymentsfilters';
import { StatusIcon } from '@library/components/StatusIcon';
import { WithdrawalsCell } from '@library/components/withdrawals/WithdrawalsCell';
import { getMethodInfo } from '@bo-utils/payments';

export interface WithdrawalsRowProps {
  withdrawal: Withdrawal;
  user: User;
  onWithdrawalRowClick: (deposits: Withdrawal) => void;
}

export const WithdrawalsRow = ({
  withdrawal,
  user,
  onWithdrawalRowClick
}: WithdrawalsRowProps) => {
  const {
    merchantReferenceId,
    method,
    amount,
    status,
    created,
    location,
    card,
    bank
  } = withdrawal;

  const { stateAbbreviation } = location || {
    stateAbbreviation: '?'
  };

  const methodInfo = getMethodInfo(
    method,
    withdrawalMethodDisplay(method),
    card,
    bank
  );

  return (
    <tr
      className={classNames(
        'border-soFresh-140 h-14 items-center border-b',
        'text-soClean-110',
        'hover:bg-soFresh-120'
      )}
      onClick={() => onWithdrawalRowClick(withdrawal)}
    >
      <WithdrawalsCell sortable>
        {`${user.id} \u2022 ${user.email}`}
      </WithdrawalsCell>

      <WithdrawalsCell sortable>{merchantReferenceId}</WithdrawalsCell>

      <WithdrawalsCell sortable>
        {formatWithTimezoneChange(
          getPaymentsDateTime(created),
          'LL/dd/yyyy t ZZZZ'
        )}
      </WithdrawalsCell>

      <WithdrawalsCell sortable>
        {`${convertCentsToDollars(amount)}`}
      </WithdrawalsCell>

      <WithdrawalsCell sortable>{methodInfo}</WithdrawalsCell>

      <WithdrawalsCell sortable>{stateAbbreviation}</WithdrawalsCell>

      <WithdrawalsCell sortable>
        <StatusIcon status={status} classes="align-middle" />
        {withdrawalStatusDisplay(status)}
      </WithdrawalsCell>
    </tr>
  );
};
